<div class="contents">
   <img src="assets/2022/imgs/onlinelook/icon_inform@2x.png" alt="">
   <div class="content">
      深度挖掘上海经济、社会、文化、历史等方面的文化内涵和教育价值，通过主题特色、文化内涵将学习点串联起来，形成人文行走学习路线。本届教博会集中展示“在线人文行走”的57条线路、357个点，满足了市民多样化的学习需求，让老百姓真正走近城市的历史积淀。
   </div>
</div>
<div class="pic">
   <img src="/assets/2022/imgs/onlinelook/experience_pic3@2x.jpg" alt="">
</div>
